export enum MasterListType {
    Service = 'service',
    Location = 'location'
}
